import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const CookiesPage: React.FC = () => {
  return (
    <Box sx={{ width: '100%', background: '#F2F2F2' }}>
      <Container maxWidth={false} sx={{ maxWidth: '1100px', px: { xs: 2, sm: 3, md: 4 }, py: { xs: 6, sm: 8 } }}>
        <Typography sx={{ fontFamily: 'Inter', fontWeight: 800, fontSize: { xs: '28px', sm: '36px' }, color: '#1F1F1F', mb: 2 }}>
          Cookies
        </Typography>
        <Typography sx={{ color: '#666', mb: 4 }}>Poslední aktualizace: {new Date().toLocaleDateString('cs-CZ')}</Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>Co jsou cookies?</Typography>
            <Typography sx={{ color: '#444' }}>
              Cookies jsou malé textové soubory, které web ukládá do vašeho zařízení, aby si zapamatoval vaše nastavení, 
              zlepšil funkčnost a analyzoval návštěvnost.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>Jaké cookies používáme</Typography>
            <Typography sx={{ color: '#444' }}>
              • Nezbytné: zajišťují základní funkce webu a přihlášení (nelze je vypnout).<br/>
              • Preferenční: pamatují si vaše volby (např. jazyk).<br/>
              • Analytické: anonymně měří návštěvnost a pomáhají zlepšovat web.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>Správa souhlasu</Typography>
            <Typography sx={{ color: '#444' }}>
              Preferenční a analytické cookies můžete odmítnout v nastavení svého prohlížeče nebo pomocí nástrojů třetích stran. 
              Nezbytné cookies jsou nutné pro provoz webu.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '18px', mb: 1 }}>Kontakt</Typography>
            <Typography sx={{ color: '#444' }}>
              Dotazy ke cookies: <a href="mailto:info@pravnibot.cz">info@pravnibot.cz</a>
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CookiesPage;

